module.exports = __webpack_public_path__ + "static/media/BajajAutoLTD2011.9d5bc8ab.png";